export const convertNumberToStringGender = (number: string) => (+number === 1 ? 'male' : 'female');
